// UserProfileJsonLd.js
'use strict';
import { connect } from 'react-redux';

import {
  USER_PROFILE_TABS,
  OUTBOX_FEED_STORY,
  OUTBOX_FEED_POST_VIDEO,
  OUTBOX_FEED_POST_IMAGE,
  OUTBOX_FEED_SHORT,
} from '../RemoteConfigKeys.js';

import UserProfileJsonLd from '../component/UserProfileJsonLd.jsx';

import getUserData from '../selector/getUserData.js';
import getMessageDataList from '../selector/getMessageDataList.js';
import getListData from '../selector/getListData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import { getFeedNameType } from '../resource/feedUtils.js';

const mapStateToProps = (state, { userId }) => {
  const [storyDataList, flixDataList, imageDataList, shortsDataList] = [
    OUTBOX_FEED_STORY,
    OUTBOX_FEED_POST_VIDEO,
    OUTBOX_FEED_POST_IMAGE,
    OUTBOX_FEED_SHORT,
  ].map(item => {
    const category = getRemoteConfigData(state, item, undefined, {
      USER_ID: userId,
    });
    const ids =
      getListData(
        state,
        ['home', getFeedNameType({ feedName: category }), category],
        'itemIds'
      ) || [];
    const messageDataList = getMessageDataList(state, ids);
    return messageDataList;
  });
  return {
    username: getUserData(state, userId, 'username'),
    biography: getUserData(state, userId, 'biography'),
    tabs: getRemoteConfigData(state, USER_PROFILE_TABS),
    storyDataList,
    flixDataList,
    imageDataList,
    shortsDataList,
  };
};

export default connect(mapStateToProps, null)(UserProfileJsonLd);
